import { createAsyncThunk } from '@reduxjs/toolkit';
import { postChangePhonenumber } from '../services/postChangePhonenumber.service';

/**
 * Callers must `.unwrap()` this. The verify step closes the dialog once it
 * resolves, and a plain dispatch resolves even when the request failed — which
 * would report success and leave the old number on every resource.
 */
export const changePhonenumber = createAsyncThunk(
  'user/changePhonenumber',
  async ({ phone }) => postChangePhonenumber(phone)
);
